export default "__VITE_ASSET__5e0a91d3__"